import { render, staticRenderFns } from "./ContractEditor.yaml?vue&type=template&id=2fc58aea&component"
import script from "./ContractEditor.yaml?vue&type=script&lang=ts&component"
export * from "./ContractEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports